import React from "react"
import { Text, Box } from "@chakra-ui/react"
import { Control, useController } from "react-hook-form"
import { URL_VALIDATOR_REGEX } from "utilities/strings"
import TextField from "./TextField"

type Props = {
  name: string
  control: Control<any>
  placeholder?: string
  disabled?: boolean
  showLabel?: boolean
  label?: string
  variant?: "outline" | "filled" | "flushed" | "unstyled";
  urlValidatorRegex?: RegExp,
  errorMessage?: string,
  helperText?: string
}

const UrlField = ({
  name,
  control,
  placeholder,
  disabled,
  showLabel,
  label,
  variant = "outline",
  urlValidatorRegex = URL_VALIDATOR_REGEX,
  errorMessage = "Link is not valid",
  helperText,
}: Props) => {
  const {
    field,
    field: { value: fieldValue },
    fieldState: { invalid },
  } = useController({
    name,
    control,
    rules: { pattern: urlValidatorRegex },
  })

  const handleBlur = () => {
    if (fieldValue && !fieldValue.startsWith("http://") && !fieldValue.startsWith("https://")) {
      field.onChange(`http://${fieldValue}`)
    }
  }

  return (
    <Box w="100%">
      {showLabel && !label && (
        <Box mb={4}>
          <Text fontWeight="semibold">URL</Text>
        </Box>
      )}
      <TextField
        disabled={disabled}
        variant={variant}
        control={control}
        placeholder={placeholder}
        name={name}
        onBlur={handleBlur}
        mb={1}
        helperText={helperText}
        error={!disabled && invalid}
        errorMessage={errorMessage}
        label={label}
      />
    </Box>
  )
}

export default UrlField
